import { render } from "./10.vue?vue&type=template&id=94830ff6"
import script from "./10.vue?vue&type=script&lang=js"
export * from "./10.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__